import { render, staticRenderFns } from "./NewFormEdit.vue?vue&type=template&id=723f541a&"
import script from "./NewFormEdit.vue?vue&type=script&lang=js&"
export * from "./NewFormEdit.vue?vue&type=script&lang=js&"
import style0 from "./NewFormEdit.vue?vue&type=style&index=0&id=723f541a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports